import Component from "../abstracts/Component";
import {isMobile, MobileBreakpoint} from "../utils/MobileUtils";

export default class ReferencesCarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousels(elem);
        // this.manageMobileCarousels();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(elem) {
    let selector = this.SELECTORS.main;
    let carousels = [];
    if (
      elem != null &&
      typeof elem != "undefined" &&
      document.getElementsByClassName(elem).length
    )
      carousels = document.getElementsByClassName(elem);
    else carousels = document.querySelectorAll(selector);

    for (let carousel of carousels) {
      let options = {
        arrows: false,
        infinite: false,
        draggable: true,
        mobileFirst: true,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 4.2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 5.2,
              slidesToScroll: 1
            }
          }
        ]
      };

      const editMode = carousel.dataset.editMode === "true" ? true : false;
      if (editMode) return false;

      $(carousel).on('init', () => {
        // this.animateArrows(carousel);
        this.$emit(this.$customEvents.CAROUSEL.initCarousel,{carousel: carousel});
      });

      $(carousel).slick(options);
    }
  }

  animateArrows(carousel) {
    let prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      console.log("afterOpen Modal");
      let carouselsIntoVex = document
        .querySelector(".vex")
        .querySelectorAll('[data-carousel="in-vex"]');
      if (carouselsIntoVex.length > 0) {
        for (let carouselInVex of carouselsIntoVex) {
          carouselInVex.dataset.carousel = "true";
        }
        this.initCarousels();
      }
    });

    this.$on(this.$customEvents.CAROUSEL.triggerCarousel, data => {
      this.importLibrary(data.payload);
    });
  }

  manageMobileCarousels() {
    let carousels = document.querySelectorAll('.slick-slider');
    for (let carousel of carousels) {
      let slickDots = $(carousel).find('.slick-dots');
      if (slickDots.length) {
        if ($(slickDots).children('li').length > 6 && $(slickDots).parent('.slick-dots-container').length == 0) {
          $(slickDots).wrap("<div class='slick-dots-container'></div>");
          $(slickDots).find('li').each(function (index) {
            $(this).addClass('dot-index-' + index);
          });
          if (slickDots.children('li').length > 14) {
            $(slickDots).css('transform', 'translateX(80px)');
          } else {
            $(slickDots).css('transform', 'translateX(40px)');
          }
          $(carousel).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let currentTranslateX = parseInt($(this).find('.slick-dots').css('transform').split(',')[4]);
            let transformCount = 0;
            if (!$(this).find('ul.slick-dots li:first-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-child(2)').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:last-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-last-child(2)').hasClass('slick-active')) {
              if (nextSlide > currentSlide) {
                if(!$(this).find('ul.slick-dots li:nth-last-child(3)').hasClass('slick-active')) {
                  transformCount = currentTranslateX - 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              } else {
                if(!$(this).find('ul.slick-dots li:nth-child(3)').hasClass('slick-active') ) {
                  transformCount = currentTranslateX + 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              }
            }
          });
        }
      }
    }
  }

  render() {
    super.render();
    if (document.querySelectorAll("[data-carousel]").length) {
      this.importLibrary();
    }
    this.bindEvents();
  }
}
